import { HTTPMETHOD } from '../../../../../enums/HTTPMETHOD.js';
import CONFIRM from '../../../../COMPONENT/dialog/confirm/CONFIRM.js';
import { DIV } from '../../../../COMPONENT/loader/LOADER.js';
import { div } from '../../../../DOM/div/DIV.js';
import ICON_LOGO from '../../../../SVG/icon/icons/ICON_LOGO.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const logoutDialogAttr = makeAttrStruct([
    ['open'],
    ['closeOnFocusOut', true]
]);
export const logoutDialogData = makeDataStruct([
    ['logoutUrl'],
    ['caller'],
    ['loader']
]);
export const logoutDialogModel = makeStruct([
    ['attributes', logoutDialogAttr],
    ['data', logoutDialogData]
]);
// Simplified Model
export function logoutDialog(logoutUrl, caller, loader) {
    return logoutDialogModel(logoutDialogAttr(true), logoutDialogData(logoutUrl, caller, loader));
}
/** A DIALOG with an embedded FORM that can be used to recieve input */
export default class LOGOUT extends CONFIRM {
    constructor(node, model) {
        super(node, model);
        this.addClass('logout');
        this.logoutUrl = model.data.logoutUrl;
        this.footer.navCenter.removeClass('horizontal');
        this.footer.navCenter.addClass('vertical');
        this.gfx = new DIV(this.flexvertical, div('gfx'));
        this.icon = new ICON_LOGO(this.gfx);
        this.iconLabel = new DIV(this.gfx, div('label')).setInnerHTML('spoonmedia');
        this.btnConfirm.setLabel('Yes, Log out');
        this.btnCancel.setLabel('No, Remain logged in');
        this.data.onConfirm = () => this.postLogout(),
            this.data.onCancel = () => console.log('Cancelled logout');
    }
    /** Post a logout request to the logout endpoint and handle response */
    postLogout() {
        this.getJson(this.logoutUrl, (payload) => {
            console.log('Logging Out', payload);
            if (payload.message.includes('Successfully logged out')) {
                console.log('Logging Out...');
                window.sessionStorage.clear();
                location.reload();
            }
            else if (payload.message.includes('Session invalid or non-existent')) {
                console.log('Clearing cached session data...');
                window.sessionStorage.clear();
                location.reload();
            }
            else {
                console.log('An unknown error occurred while attempting to log out');
                window.sessionStorage.clear();
                location.reload();
            }
        }), HTTPMETHOD.POST, '', '', {
            'username': window.sessionStorage.getItem('username'),
            'password': window.sessionStorage.getItem('password')
        };
    }
}
;
/** Handles the Login Payload
    @param payload Login Payload
    @param status Status Code

    loginHandler(payload, status): void {
        console.log('loginHandler');
        try {
            if (payload.result[0].className === 'AuthenticationException') {
                this.loader.warn(100, 'Unable to Authenticate');
                console.log('Unable to Authenticate', status, payload.result[0]);
                // Make some sort of visual cue to inform user to attempt again
            } else {
                console.log('LOGIN FORM', status, payload);
                // Save Session details in sessionStorage
                Object.keys(payload.result[0]).forEach((key) => window.sessionStorage.setItem(key, payload.result[0][key]));
                // Close the loader, dialog etc and trigger page load
                this.loader.log(100, 'Login Successful').then(() => {
                    // Prompt for Browser Save Password
                    history.pushState({}, document.title);
                    // Initialize
                    this.closeDialog().then(() => this.caller.getMain().initialize());
                });
            }
        } catch (e) {
            if (!(e instanceof TypeError)) {
                console.error('Unknown error occurred', e)
            }
        }
    }
}
*/ 
